import { NOTIFICATION_ACTIONS } from './actions';

export const notificationTypes = {
  error: 'error',
  info: 'info',
  warning: 'warning',
  success: 'success',
};

const showNotificationMessage = (type: string, message: string, dispatch) => {
  dispatch({
    type: NOTIFICATION_ACTIONS.SHOW_NOTIFICATION,
    payload: {
      type,
      message,
    },
  });
};

export const showSuccessNotification = (message, dispatch) => {
  dispatch({
    type: NOTIFICATION_ACTIONS.SHOW_NOTIFICATION,
    payload: {
      type: notificationTypes.success,
      message,
    },
  });
};
export const showErrorNotification = (message, dispatch) => {
  dispatch({
    type: NOTIFICATION_ACTIONS.SHOW_NOTIFICATION,
    payload: {
      type: notificationTypes.error,
      message,
    },
  });
};
export const showWarningNotification = (message, dispatch) => {
  dispatch({
    type: NOTIFICATION_ACTIONS.SHOW_NOTIFICATION,
    payload: {
      type: notificationTypes.warning,
      message,
    },
  });
};

export const showInfoNotification = (message, dispatch) => {
  dispatch({
    type: NOTIFICATION_ACTIONS.SHOW_NOTIFICATION,
    payload: {
      type: notificationTypes.info,
      message,
    },
  });
};
export default showNotificationMessage;
